// Curated imagery for the Saferide landing page
export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1606059979642-8390434af3d5?auto=format&fit=crop&w=1600&q=80",
  scenic: "https://images.unsplash.com/photo-1494822493217-c9840aba840c?auto=format&fit=crop&w=1400&q=80",
  routeAerial: "https://images.pexels.com/photos/16024655/pexels-photo-16024655.jpeg?auto=compress&cs=tinysrgb&w=1400",
  offerRide: "https://images.unsplash.com/photo-1773063449875-332dff62b6e3?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  bookRide: "https://images.pexels.com/photos/8892463/pexels-photo-8892463.jpeg?auto=compress&cs=tinysrgb&w=1200",
  friends: "https://images.unsplash.com/photo-1756142008330-87dc106322a4?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  driver: "https://images.pexels.com/photos/5967001/pexels-photo-5967001.jpeg?auto=compress&cs=tinysrgb&w=1000",
};

export const ROUTES = [
  "CALGARY → EDMONTON",
  "REGINA → SASKATOON",
  "WINNIPEG → BRANDON",
  "EDMONTON → RED DEER",
  "SASKATOON → PRINCE ALBERT",
  "CALGARY → LETHBRIDGE",
  "REGINA → MOOSE JAW",
  "EDMONTON → FORT McMURRAY",
];
